import React from "react";

import { setupActions } from "../actions";
import { connect } from "react-redux";

import { Spinner } from "components/Icons/Spinner";
import { Row, Col } from "reactstrap";

import { SysUsers } from "../components/SysUsers";

var viewActions = require("store/view.actions");

class SysUsersConfigPage extends React.Component {
  componentDidMount() {
    this.props.setMainTitle("Panel de control", []);
    this.props.getSysUsers(this.props.token);
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="content">
          {!this.props.view.loadingModules.getSysUsers ? (
            <Row>
              <Col md="12">
                <Row>
                  {this.props.sysUsers && (
                    <SysUsers users={this.props.sysUsers} />
                  )}
                </Row>
              </Col>
            </Row>
          ) : (
            <Spinner size="XL" />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCalendarID: state.school.currentCalendarID,
    view: state.view,
    school: state.config.school,
    token: state.auth.session.jwt_token,
    sysUsers: state.setup.sysUsers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMainTitle: (title, menu) => {
      dispatch(viewActions.setMainTitle(title, menu));
    },
    getSysUsers: (token) => {
      dispatch(setupActions.getSysUsers(token));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SysUsersConfigPage);
